module.exports = __webpack_public_path__ + "static/cadastroLocal-c8f2c4dcfae4dcbfcf7cc9b4a3110b8b.gif";